import React from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import Marked from 'react-markdown'
import Price from './Price.js'
import './ProductSingle.css'
import ImageSlider from '../ImageSlider'

const ProductSingle = ({galleryItems, router}) => {
  const id = router.match.params.id
  const product = galleryItems.find(product => product.name === id)

  function renderProduct (product) {
    if (!product) return <div className='ProductError'>No Product Found <Link to='/'>Back to home</Link></div>
    const {
      images,
      title,
      description,
      stock,
      buyUrl,
      currency_code: currencyCode,
      madeBy,
      madeWith
    } = product

    const price = parseFloat(product.price)
    const creator = madeBy || 'Catherine Stainton'

    return (
      <div className='ProductSingle'>
        <div className='ProductSingleContainer'>
          <div className='gallery'>
            <ImageSlider alt={title} images={images.map(item => item.image)} />
          </div>
          <div className='details'>
            <h1 className='title' dangerouslySetInnerHTML={{__html: title}} />
            <div className='detail'>
              <h3 className='subtitle'>Description</h3>
              <Marked className='description' source={description} />
            </div>
            { madeWith
              ? <div className='detail'>
                <h3 className='subtitle'>Made with</h3>
                <p className='materials'>
                  {madeWith}
                </p>
              </div>
              : null }
            { creator
              ? <div className='detail'>
                <h3 className='subtitle'>Made by</h3>
                <p className='creator'>
                  {creator}
                </p>
              </div> : ''
            }
            { price > 0 &&
              <div className='detail'>
                <h3 className='subtitle'>Quantity</h3>
                <p className='quantity'>
                  {stock > 0
                    ? (`${stock} Available`)
                    : <p className='price sold'>Sold</p>
                  }
                </p>
              </div>
            }
            { !isNaN(price) && price > 0 &&
              <div className='detail'>
                <h3 className='subtitle'>Price</h3>
                <p className='price'><Price price={price} code={currencyCode} /></p>
              </div>
            }
            { (stock > 0 && buyUrl) && <a className='button buy' href={buyUrl}>Buy</a> }
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='ProductSingle fadeIn'>
      <section className='section'>
        <div className='container'>
          {renderProduct(product)}
        </div>
      </section>
      <Helmet title={product.title} />
    </div>
  )
}

export default ProductSingle



// WEBPACK FOOTER //
// ./src/Shop/ProductSingle.js